/**
 * Various object-related utils
 */
export default class Objects {
    public static sameObject<T>(a: T, b: T, ignoreKeys?: string[]): boolean {
        if (a === b) {
            return true
        }
        if (a === undefined || a === null || b === null || b === undefined) {
            return false
        }
        if (typeof a === "object" && typeof b === "object") {
            for (const aKey in a) {
                if (!(aKey in b)) {
                    return false
                }
            }

            for (const bKey in b) {
                if (!(bKey in a)) {
                    return false
                }
            }
            for (const k in a) {
                if (!Objects.sameObject(a[k], b[k])) {
                    return false
                }
            }
            return true
        }
        return false
    }
}
